import FillFormImage from '../../assets/images/fill-form.svg';
import Container from '@material-ui/core/Container';


const FirstBox = () => {
    return (
        <Container className="container-form transparent-content" style={{ marginTop: "0px" }}>
            <div className="row d-flex justify-content-center">
                <img src={FillFormImage} alt="fill-form" />
            </div>
            <br />
            <div className="row">
                <div className="col-12">
                    <span className="title-7 title-advanced">Estás a un paso de experimentar nuestras soluciones.</span>
                    <br/>
                    <span className="text-4 text-size">
                        Completa el formulario y sigue los pasos para comenzar tu prueba gratis.
                    </span>
                </div>
            </div>
        </Container>
    );
};

export default FirstBox;
